import { useEffect } from "react";
import Lottie from "lottie-react";
import lottieAnim from "../../../assets/lottie/Faglig_viden.json";

export default function Sektion({
  pauseAll,
  lottieRef,
  htmlRef,
}: {
  pauseAll: (lottieRef: any) => void;
  lottieRef: any;
  htmlRef: any;
}) {
  useEffect(() => {
    const playVideoWhenInView = (entries: IntersectionObserverEntry[]) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          pauseAll(lottieRef);
          lottieRef.current?.play();
        } else {
          lottieRef.current?.pause();
        }
      });
    };

    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 1,
    };

    const observer = new IntersectionObserver(playVideoWhenInView, options);

    if (htmlRef.current) {
      observer.observe(htmlRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, [htmlRef, lottieRef, pauseAll]);

  return (
    <div className="mx-auto grid grid-cols-1 border-b md:border-none md:grid-cols-2 mx-auto items-center gap-4 items-start container md:py-32 pb-[32px] md:pb-[40px] mb-8 md:pb-0">
      <div className="md:mb-0 md:container order-2 md:order-1">
        <h2 className="dtext-dxl md:text-d2xl font-bold text-doctio-green">
          Journalføring & faglig information på ét sted
        </h2>
        <p>
          Doctio forener journalføring og klinisk viden på ét centralt sted.
          Vores platform integrerer journalføring med relevant klinisk
          information. I selve fraserne findes informationsbokse, der leverer
          hurtig opslag af fagtermer, behandlingsplaner, egne noter, flowcharts
          osv. Foruden dette er der nederste i hver fraser mulighed for at
          tilføje og tilgå strukturerede noter, overvejelser, links, relevant
          video- og billedemateriale samt dokumenter; såsom patientinformation,
          behandlingsvejledninger og instrukser mm.
        </p>
        <a href="/signup" className="text-doctio-green font-bold">
          Prøv det gratis
        </a>
      </div>

      <div className="flex justify-center md:container order-1 md:order-2">
        <div ref={htmlRef} className="player w-full">
          <Lottie
            animationData={lottieAnim}
            autoplay={false}
            loop={true}
            lottieRef={lottieRef}
            className="player"
          />
        </div>
      </div>
    </div>
  );
}
